export default __webpack_public_path__ + "static/media/google.4a698f39.png";